import { useEffect, useState } from "react";

/**
 * Android app-mode detection.
 *
 * Returns true ONLY when the current user agent contains BOTH
 * "AlkoholprovetApp" and "Android". The `app=1` query flag alone does
 * NOT enable Android app-mode — that flag is used for iOS/general
 * WebView tweaks and must not trigger Google Play purchase restrictions.
 */
export function useAndroidAppMode(): boolean {
  const [isAndroidApp, setIsAndroidApp] = useState(false);

  useEffect(() => {
    if (typeof navigator === "undefined") return;
    const ua = navigator.userAgent || "";
    if (ua.includes("AlkoholprovetApp") && ua.includes("Android")) {
      setIsAndroidApp(true);
      try {
        document.documentElement.classList.add("android-app-mode");
      } catch {}
    }
  }, []);

  return isAndroidApp;
}
